const destinations = [
  {
    icon: "ri-ship-line",
    title: "The Bahamas &amp; Caribbean",
    description:
      "Caribbean cruises from Port Tampa Bay, Port Everglades, and Port of Miami are Southwest Florida's most popular international trips. Estero residents board western Caribbean itineraries to Cozumel, Grand Cayman, and Jamaica; eastern Caribbean routes to St. Thomas, San Juan, and the Bahamas; and southern Caribbean voyages to Aruba, Curacao, and Barbados. Many retirees book these cruises as part of their winter snowbird lifestyle, while families choose spring break and summer Caribbean getaways. The six-month validity rule often surprises travelers whose passports expire shortly after their return date.",
    tags: ["Cruises", "Beach", "Resorts"],
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Canada",
    description:
      "Canadian travel is significant for Estero's large population of former Midwest and Northeast residents. Summer returns to Toronto, Ottawa, Montreal, and Vancouver to visit family are a longstanding tradition. Direct seasonal flights from RSW to Toronto and Montreal make this easier than ever. Retirees who spent their working years in Michigan, Ohio, Illinois, and Wisconsin maintain deep family connections across the border, and their grandchildren's graduations, weddings, and milestone birthdays create predictable annual travel demand.",
    tags: ["Family Visits", "Summer Travel", "Direct Flights"],
  },
  {
    icon: "ri-landscape-line",
    title: "Europe",
    description:
      "European destinations draw Estero travelers for river cruises along the Rhine and Danube, cultural tours of London, Paris, Rome, and Barcelona, and Mediterranean cruises from Rome or Barcelona. The Schengen three-month validity rule catches many retirees who assume their passport is fine because it has not expired. Academic travel from FGCU also generates significant European demand — research collaborations, conferences, and professional development trips to the UK, Germany, France, and the Netherlands.",
    tags: ["River Cruises", "Culture", "Academic Travel"],
  },
  {
    icon: "ri-treasure-map-line",
    title: "United Kingdom &amp; Ireland",
    description:
      "The UK and Ireland are popular for heritage travel, golf trips to Scotland and Ireland, and London city breaks. The six-month validity requirement is particularly strict for UK entry — we see more passport emergencies from UK-bound travelers than almost any other destination. Retirees often book these trips well in advance through tour operators, then discover passport issues when final travel documents are distributed. The weak pound has also made Britain an increasingly attractive destination for budget-conscious travelers from Southwest Florida.",
    tags: ["Heritage", "Golf", "City Breaks"],
  },
  {
    icon: "ri-sun-line",
    title: "Mexico",
    description:
      "Cancun, Riviera Maya, Puerto Vallarta, and Cabo San Lucas are top Mexican destinations for Estero families and retirees. Winter escapes to all-inclusive resorts are a snowbird staple, while spring break trips draw families with school-age children. The Mexico six-month validity rule applies to all passport holders, and the child passport trap hits hard here — many parents book that first Cancun trip, then discover their 8-year-old's passport expired last year. Land crossings to Baja California also require valid documentation.",
    tags: ["Resorts", "Spring Break", "Winter Escape"],
  },
  {
    icon: "ri-compass-3-line",
    title: "Panama Canal &amp; Central America",
    description:
      "Panama Canal cruises, Costa Rica eco-tours, and Belize diving trips appeal to Estero's active retiree and outdoor adventure demographic. These trips often book 9–12 months in advance through adventure travel companies and cruise lines, creating a long window during which passports can expire unnoticed. FGCU's strong environmental science and marine biology programs also generate academic travel to Central America for research, field work, and conservation partnerships.",
    tags: ["Eco-Tours", "Cruises", "Adventure"],
  },
];

const stats = [
  { value: "55%", label: "Caribbean cruise or Canadian family visit requests" },
  { value: "RSW", label: "Primary airport — 15–20 min from Estero" },
  { value: "Nov–Apr", label: "Peak travel season for snowbirds &amp; cruises" },
  { value: "36 hr", label: "Shortest emergency turnaround handled" },
];

export default function EsteroDestinationsSection() {
  return (
    <section id="destinations" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Popular Destinations
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Estero Residents Travel
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            From Caribbean cruises to Canadian family reunions, here is where Estero travelers are heading — and the passport rules that matter for each destination.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {destinations.map((d, i) => (
            <div
              key={i}
              className="bg-[#F8F9FB] rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all hover:shadow-md"
            >
              <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center mb-4">
                <i className={`${d.icon} text-[#F6C344] text-lg`}></i>
              </div>
              <h3 className="font-serif text-base font-bold text-[#1A365D] mb-3">{d.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{d.description}</p>
              <div className="flex flex-wrap gap-2">
                {d.tags.map((tag, j) => (
                  <span
                    key={j}
                    className="inline-block bg-white text-[#1A365D] text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full border border-gray-200"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="bg-[#1A365D] rounded-lg p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {stats.map((s, i) => (
              <div key={i}>
                <div className="text-[#F6C344] font-bold text-2xl md:text-3xl mb-1">{s.value}</div>
                <div className="text-white/70 text-xs">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}